module.exports = __webpack_public_path__ + "img/spain-external-causes-female.4736a842.png";